import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";

const DEMO_APIS = [
  {
    path: "/users",
    method: "GET",
    summary: "List all users",
    category: "User",
    template: {
      method: "GET",
      url: "/users",
      headers: { "Content-Type": "application/json" },
      query_params: { limit: "string", offset: "string" },
      path_params: {},
      body: {}
    }
  },
  {
    path: "/users",
    method: "POST",
    summary: "Create a new user",
    category: "User",
    template: {
      method: "POST",
      url: "/users",
      headers: { "Content-Type": "application/json", Authorization: "Bearer <token>" },
      query_params: {},
      path_params: {},
      body: { name: "string", email: "string", password: "string" }
    }
  },
  {
    path: "/users/{id}",
    method: "GET",
    summary: "Get user by ID",
    category: "User",
    template: {
      method: "GET",
      url: "/users/{id}",
      headers: { "Content-Type": "application/json" },
      query_params: {},
      path_params: { id: "string" },
      body: {}
    }
  },
  {
    path: "/users/{id}",
    method: "PUT",
    summary: "Update user",
    category: "User",
    template: {
      method: "PUT",
      url: "/users/{id}",
      headers: { "Content-Type": "application/json", Authorization: "Bearer <token>" },
      query_params: {},
      path_params: { id: "string" },
      body: { name: "string", email: "string" }
    }
  },
  {
    path: "/users/{id}",
    method: "DELETE",
    summary: "Delete user",
    category: "User",
    template: {
      method: "DELETE",
      url: "/users/{id}",
      headers: { "Content-Type": "application/json", Authorization: "Bearer <token>" },
      query_params: {},
      path_params: { id: "string" },
      body: {}
    }
  },
  {
    path: "/auth/login",
    method: "POST",
    summary: "User login",
    category: "Authentication",
    template: {
      method: "POST",
      url: "/auth/login",
      headers: { "Content-Type": "application/json" },
      query_params: {},
      path_params: {},
      body: { email: "string", password: "string" }
    }
  },
  {
    path: "/auth/logout",
    method: "POST",
    summary: "User logout",
    category: "Authentication",
    template: {
      method: "POST",
      url: "/auth/logout",
      headers: { "Content-Type": "application/json", Authorization: "Bearer <token>" },
      query_params: {},
      path_params: {},
      body: {}
    }
  },
  {
    path: "/payment/charge",
    method: "POST",
    summary: "Process payment",
    category: "Finance",
    template: {
      method: "POST",
      url: "/payment/charge",
      headers: { "Content-Type": "application/json", Authorization: "Bearer <token>" },
      query_params: {},
      path_params: {},
      body: { amount: "number", currency: "string", card_token: "string" }
    }
  },
  {
    path: "/weather/current",
    method: "GET",
    summary: "Get current weather",
    category: "Weather",
    template: {
      method: "GET",
      url: "/weather/current",
      headers: { "Content-Type": "application/json" },
      query_params: { city: "string", units: "string" },
      path_params: {},
      body: {}
    }
  }
];

function App() {
  const [file, setFile] = useState(null);
  const [apis, setApis] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("demo") === "1") {
      setApis(DEMO_APIS);
    }
  }, []);

  const uploadFile = async () => {
    if (!file) return alert("Upload a file first");

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    try {
      const res = await axios.post("http://localhost:8000/upload", formData);
      setApis(res.data.apis);
    } catch (err) {
      alert("Error uploading file");
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <h1>🚀 API Explorer</h1>

      <div className="upload-box">
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
        <button onClick={uploadFile}>Upload OpenAPI</button>
      </div>

      {loading && <p>Processing...</p>}

      <div className="api-list">
        {apis.map((api, index) => (
          <div className="card" key={index}>
            <div className="card-header">
              <span className={`method ${api.method.toLowerCase()}`}>
                {api.method}
              </span>
              <span className="path">{api.path}</span>
            </div>

            <p className="category">📂 {api.category}</p>

            <details>
              <summary>View Template</summary>
              <pre>{JSON.stringify(api.template, null, 2)}</pre>
            </details>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;